import { render } from "./WebphoneLlamadaEntrante.vue?vue&type=template&id=2216332e&scoped=true"
import script from "./WebphoneLlamadaEntrante.vue?vue&type=script&lang=js"
export * from "./WebphoneLlamadaEntrante.vue?vue&type=script&lang=js"

import "./WebphoneLlamadaEntrante.vue?vue&type=style&index=0&id=2216332e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2216332e"]])

export default __exports__